import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePicker } from 'primeng/datepicker';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { LeadService } from 'src/app/private/services/lead.service';
import { FollowUpService } from 'src/app/private/services/micro-services/followup.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-lead-followup-form-popup',
  imports: [SharedModule, FormsModule, ButtonModule, CheckboxModule, DatePicker, DividerModule, InputTextModule, SelectModule, TextareaModule],
  templateUrl: './lead-followup-form-popup.component.html',
  styleUrl: './lead-followup-form-popup.component.scss'
})
export class LeadFollowupFormPopupComponent {
   selectedFollowup = '';
    selectedStatus = '';
    nextFollowUp = '';
    remarks = '';
    isSetReminder = false;
    reminderDate: Date | null = null;
    lead_id: any;
    loading = false;
    nextFollowupDate = null;
    minDate: Date = new Date();
    @Input() leadData?: any;
    @Output() closeDialog = new EventEmitter<void>();

    constructor(
      private api: LeadService,
      private localStorage: LocalStorageService,
      private route: ActivatedRoute,
      private FollowUpService: FollowUpService,
      private messageService: MessageService,
      private leadActivityService: LeadActivityService
    ) {
      this.lead_id = this.route.snapshot.paramMap.get('id');
    }
  
    ngOnInit(){
      console.log(" lead ", this.leadData)
      if (this.leadData) {
        
        this.lead_id = this.leadData.lead_id;
      }
    }
  
    followupOptions = [
      { label: 'Call', value: 'Call' },
      { label: 'Email', value: 'Email' },
      { label: 'Meeting', value: 'Meeting' },
      { label: 'SMS', value: 'SMS' },
      { label: 'WhatsApp', value: 'WhatsApp' },
      { label: 'Other', value: 'Other' }
    ];
      minReminderDate: Date = (() => {
        const d = new Date();
        d.setDate(d.getDate() + 1);
        d.setHours(0, 0, 0, 0);
        return d;
      })();
  
    followupDate = null;
  
    statusOptions = [
      { label: 'Pending', value: 'Pending' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Cancelled', value: 'Cancelled' }
    ];
  
  
    submitForm() {
      if (!this.selectedFollowup) {
        this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Please select followup mode'
        });
        return;
      }
      if (!this.nextFollowUp) {
        this.messageService.add({
          severity: 'error', summary: 'Error', detail: 'Please enter follow up action'
        });
        return;
      }
      if (!this.followupDate) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select follow up date' });
        return;
      }
      this.loading = true;
      const payload: any = {
        organization_id: this.localStorage.getOrganizationId(),
        lead_id: this.lead_id,
        followup_mode: this.selectedFollowup,
        remarks: this.remarks,
        next_followup_action: this.nextFollowUp,
        followup_date: this.followupDate,
        is_reminder: this.isSetReminder,
        user_id: this.localStorage.getUserId()
      };
      if (this.reminderDate) {
        payload.reminder_date = this.reminderDate;
      }
      this.api.createLeadFollowup(payload).subscribe({
        next: data => {
          this.loading = false;
          this.FollowUpService.addFollowUp(data);
          this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
          this.selectedFollowup = '';
          this.nextFollowUp = '';
          this.remarks = '';
          this.isSetReminder = false;
          this.reminderDate = null;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Followup created successfully' });
          this.closeDialog.emit();
        },
        error: error => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create followup' });
          console.error('Error creating followup:', error);
        }
      });
    }
}
